import React from 'react';
import PropTypes from 'prop-types';

import MapPointerIcon from '../icons/MapPointerIcon';

const BookingFormLocation = ({ hotelName }, context) => (
  <div className="BookingFormLocation">
    <MapPointerIcon />
    <div className="header-title font-weight-bold">
      {context.t('Destination')}
    </div>
    <span className="title info-text">
      {hotelName}
    </span>
  </div>
);

BookingFormLocation.propTypes = {
  hotelName: PropTypes.string,
};

BookingFormLocation.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default BookingFormLocation;
